import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import '../styles/contact.css';
import contactimg from '../assets/images/contact.png';
import FeatureCard4 from './feature-card4';
import contactData from '../utils/contactData.js';

// Optional: Set the app element to handle accessibility
Modal.setAppElement('#root');

const Contact = (props) => {
  const [email, setEmail] = useState('');
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    fetch('https://portfolio-eepg.onrender.com/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, title, message })
    })
      .then(response => response.text())
      .then(data => {
        console.log('Success:', data);
        setModalMessage('Email sent successfully!');
        setIsModalOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error:', error);
        setModalMessage('Failed to send email.');
        setIsModalOpen(true);
        setLoading(false);
      });
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="contact-contact" id="contacts">
      <h1 className="contact-text">{props.heading}</h1>
      <div className="contact-separator"></div>
      <div className="contact-container">
        <div className="contact-feature-cards">
          {contactData.map((contact, index) => (
            <FeatureCard4
              rootClassName="rootClassName1"
              key={index}
              title={contact.Title}
              description={contact.Description}
              url={contact.url}
              icon={contact.icon}
            />
          ))}
        </div>
        <div className="contact-form-container">
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="email"
              className="contact-input"
              placeholder="Your Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="text"
              className="contact-input"
              placeholder="Title"
              required
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <textarea
              className="contact-textarea"
              placeholder="Your Message"
              required
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>
            <button type="submit" className="contact-submit" disabled={loading}>
              {loading ? 'Sending...' : 'Send'}
            </button>
          </form>
        </div>
        <div className="contact-image-container">
          <img
            alt={props.imageAlt}
            src={props.imageSrc}
            className="contact-image"
          />
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="Email Status"
        className="modal"
        overlayClassName="overlay"
      >
        <h2>{modalMessage}</h2>
        <button onClick={closeModal}>Close</button>
      </Modal>
    </div>
  );
};

Contact.defaultProps = {
  heading: 'Contact Me',
  imageSrc: contactimg,
  imageAlt: 'image',
};

Contact.propTypes = {
  heading: PropTypes.string,
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
};

export default Contact;
